import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ModalButtonClose } from "../generic/common/ModalButtonClose";
import { TextLoca } from "../generic/text/TextLoca";
import { ModalInfoButton } from "../modals/ModalInfoButton";
import { ModalOverlay } from "../modals/ModalOverlay";
export var DialogWrapper = function (_a) {
    var titleLocaId = _a.titleLocaId, onClose = _a.onClose, _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children, onInfoClick = _a.onInfoClick, FooterComponent = _a.footerRenderer;
    return (React.createElement(ModalOverlay, { onCloseOverride: onClose },
        React.createElement("div", { className: "modal " + IdStyles.ModalBackground + " " + className },
            React.createElement("div", { className: "modal-content" },
                React.createElement("header", { className: "modal-header wooden-texture-background " + IdStyles.ModalHeader },
                    React.createElement("div", { className: "modal-header__title" },
                        React.createElement("h1", { className: "modal-header__title-text" }, titleLocaId && (React.createElement(TextLoca, { id: titleLocaId, className: IdStyles.HeadlineOne })))),
                    onClose && (React.createElement(ModalButtonClose, { onClick: onClose, className: "modal-header__close" }))),
                React.createElement("section", { className: "modal-section" }, children),
                React.createElement("footer", { className: IdStyles.ModalFooter + " wooden-texture-background-flipped" },
                    FooterComponent,
                    React.createElement(ModalInfoButton, { onClick: onInfoClick }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/dialog/DialogWrapper.tsx
// module id = 31
// module chunks = 3